import { UntypedFormControl } from '@angular/forms';
import { AccountsService } from 'src/app/services/accounts.service';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Account } from 'src/app/models/account.model';
import { AuthenticatedUser, AuthenticationService } from '@aveva/connect-web-core';
import { debounceTime, distinctUntilChanged, firstValueFrom, map, merge, mergeMap, of, startWith } from 'rxjs';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-account-selector-input-async',
  templateUrl: './account-selector-input-async.component.html',
  styleUrls: ['./account-selector-input-async.component.scss']
})
export class AccountSelectorInputAsyncComponent implements OnInit {
  constructor(
    private accountsService: AccountsService,
    private authenticationService: AuthenticationService,
    private logger: LoggingService) { }

  ngOnInit(): void {
    merge(this.serviceCtrl.valueChanges)
      .pipe(
        startWith(''),
        map((value: any) => typeof(value) === typeof('') ? value : null),
        debounceTime(500),
        distinctUntilChanged(),
        mergeMap(search => of(search)))
    .subscribe((value) => this.filterAccounts(value));
  }

  serviceSelected(event: MatAutocompleteSelectedEvent): void {
    this.selectedAccountId = event.option.value.id;
    this.selected.emit(event.option.value.id);
  }

  clear = (): void => this.serviceCtrl.setValue(undefined);

  autocompleteDisplay = (account: Account): string => account ? account.account_name : undefined;

  async loadAccountsData() {
    this.loadingSpinner.emit(true);
    try {
      this.user = await this.authenticationService.getUser();
      this.accounts = this.isAccountsAll ? 
        await firstValueFrom(this.accountsService.getAccountsAll()) : 
        await firstValueFrom(this.accountsService.getAccounts(this.user?.email));
      this.loadingSpinner.emit(false);
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async filterAccounts(value: any): Promise<void> {
    try {
      value = (value || '').trim().toLowerCase();
      
      if(this.accounts == null || this.accounts === undefined) {
        await this.loadAccountsData();
      }
      
      if (value === this.previousFilter) {
        this.filteredAccounts = await this.accounts;
        return;
      }

      this.previousFilter = value;
      this.filteredAccounts = await this.accounts.filter(x => x.account_name.toLowerCase().includes(value));
    }
    catch (exception) {
      this.logger.logException(exception);
    }
  }

  user: AuthenticatedUser;
  serviceCtrl = new UntypedFormControl();
  accounts: Account[];
  account: Account;
  selectedAccountId = 0;
  filteredAccounts: Account[];
  
  private previousFilter = '';

  @Input() isAccountsAll: boolean = false;
  @Output() selected: EventEmitter<any> = new EventEmitter();
  @Output() cleared: EventEmitter<any> = new EventEmitter();
  @Output() loadingSpinner: EventEmitter<boolean> = new EventEmitter();

}
